/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";

/**
 *
 * @export
 * @interface StaffInstructorEnrollmentRequestDTO
 */
export interface StaffInstructorEnrollmentRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  program?: ProgramTypeRefOptional;
  /**
   *
   * @type {PersonRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  personId?: PersonRefOptional;
}

export interface StaffInstructorEnrollmentRequestDTO extends StaffInstructorEnrollmentRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  classInstance: UnifiedClassInstanceRef;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  program: ProgramTypeRef;
  /**
   *
   * @type {PersonRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  personId: PersonRef;
}

export interface StaffInstructorEnrollmentRequestDTOTrackedI {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefTrackedI;
  classInstanceIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  program?: ProgramTypeRefTrackedI;
  programIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof StaffInstructorEnrollmentRequestDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set(
  "StaffInstructorEnrollmentRequestDTO",
  function (model: StaffInstructorEnrollmentRequestDTO) {
    const transformDatesclassInstance = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesclassInstance && model.classInstance) {
      transformDatesclassInstance(model.classInstance);
    }
    const transformDatesprogram = transformDatesMap.get("ProgramTypeRef");
    if (transformDatesprogram && model.program) {
      transformDatesprogram(model.program);
    }
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
  },
);

export type StaffInstructorEnrollmentRequestDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  classInstance: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  program: PropertyMeta<ProgramTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
}>;

export var StaffInstructorEnrollmentRequestDTOMeta: StaffInstructorEnrollmentRequestDTOMetaI =
  {} as StaffInstructorEnrollmentRequestDTOMetaI;
StaffInstructorEnrollmentRequestDTOMeta = typeMeta(
  "StaffInstructorEnrollmentRequestDTO",
  {
    classInstance: propertyMeta(
      "classInstance",
      false,
      true,
      false,
      UnifiedClassInstanceRefMeta,
    ),
    program: propertyMeta("program", false, true, false, ProgramTypeRefMeta),
    personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  },
);

const metaI = StaffInstructorEnrollmentRequestDTOMeta;

registerMeta(() => {});

export class StaffInstructorEnrollmentRequestDTOTracked implements StaffInstructorEnrollmentRequestDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  classInstance__I?: UnifiedClassInstanceRefTracked = undefined;
  classInstanceIsSet: boolean = false;
  set classInstance(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.classInstance__I = v;
      this.classInstanceIsSet = true;
    } else {
      this.classInstance__I = v || undefined;
      this.classInstanceIsSet = true;
    }
    this.changeTracker = true;
  }
  get classInstance() {
    return this.classInstance__I;
  }
  program__I?: ProgramTypeRefTracked = undefined;
  programIsSet: boolean = false;
  set program(v: undefined | ProgramTypeRefTracked) {
    if (v !== undefined) {
      this.program__I = v;
      this.programIsSet = true;
    } else {
      this.program__I = v || undefined;
      this.programIsSet = true;
    }
    this.changeTracker = true;
  }
  get program() {
    return this.program__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(
    config?: StaffInstructorEnrollmentRequestDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.classInstance?.setIds();

    this.program?.setIds();

    this.personId?.setIds();
  }
  assignFrom(
    config: StaffInstructorEnrollmentRequestDTOOptional,
    options?: AssignOptions,
  ): StaffInstructorEnrollmentRequestDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.classInstance &&
      this.classInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.classInstance = new UnifiedClassInstanceRefTracked(
        config.classInstance,
        options,
      );
      if (optionsRequired.unassign) this.classInstanceIsSet = false;
      else this.classInstanceIsSet = true;
    }
    if (config.program && this.programApplyFilter(optionsRequired.filter)) {
      this.program = new ProgramTypeRefTracked(config.program, options);
      if (optionsRequired.unassign) this.programIsSet = false;
      else this.programIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(
    filter?: FilterVarsType,
  ): StaffInstructorEnrollmentRequestDTOTrackedI {
    const cloned = {} as StaffInstructorEnrollmentRequestDTOTrackedI;
    if (
      this.classInstanceIsSetDeep() &&
      this.classInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classInstanceIsSet = true;
      cloned.classInstance = this.classInstance?.removeUnset(filter);
    } else {
      //cloned.classInstanceIsSet = false
    }
    if (
      this.programIsSetDeep() &&
      this.programApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIsSet = true;
      cloned.program = this.program?.removeUnset(filter);
    } else {
      //cloned.programIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    return cloned;
  }
  unassignAll(
    filter?: FilterVarsType,
  ): StaffInstructorEnrollmentRequestDTOTrackedI {
    if (!this.classInstanceApplyFilter(filter)) this.classInstanceIsSet = false;
    this.classInstance?.unassignAll(filter);

    if (!this.programApplyFilter(filter)) this.programIsSet = false;
    this.program?.unassignAll(filter);

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  classInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffInstructorEnrollmentRequestDTOMeta.classInstance,
      StaffInstructorEnrollmentRequestDTOMeta,
      this.classInstance,
      this,
    );
  }
  classInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classInstanceIsSet && this.classInstanceApplyFilter(filter))
      return true;
    return this.classInstance?.anySet(filter) == true;

    return false;
  }
  programApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffInstructorEnrollmentRequestDTOMeta.program,
      StaffInstructorEnrollmentRequestDTOMeta,
      this.program,
      this,
    );
  }
  programIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIsSet && this.programApplyFilter(filter)) return true;
    return this.program?.anySet(filter) == true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffInstructorEnrollmentRequestDTOMeta.personId,
      StaffInstructorEnrollmentRequestDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.classInstanceIsSetDeep(filter)) return true;
    if (this.programIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
